/**
 * Overlay dispatch map. `ToothSVGV2` reads this to render a condition's
 * overlay component instead of hard-coded shapes. Each component receives
 * `{ type, surfaces, toothId, grade }` — unused props are ignored safely.
 */
import Caries           from "./Caries";
import RCT              from "./RCT";
import Composite        from "./Composite";
import Amalgam          from "./Amalgam";
import Implant          from "./Implant";
import Bridge           from "./Bridge";
import Missing          from "./Missing";
import Fracture         from "./Fracture";
import Crown            from "./Crown";
import Mobility         from "./Mobility";
import PeriapicalLesion from "./PeriapicalLesion";

export const OVERLAY_MAP = {
  caries:            Caries,
  rct:               RCT,
  composite:         Composite,
  gic:               Composite,   // same visual family
  filling:           Composite,
  amalgam:           Amalgam,
  implant:           Implant,
  bridge:            Bridge,
  pontic:            Bridge,
  abutment:          Bridge,
  missing:           Missing,
  extraction:        Missing,
  fracture:          Fracture,
  crown:             Crown,
  veneer:            Crown,
  onlay:             Crown,
  mobility:          Mobility,
  periapical_lesion: PeriapicalLesion,
  periapical:        PeriapicalLesion,
};

// Conditions that visually *replace* the tooth (hide crown/root beneath).
export const REPLACES_TOOTH = new Set(["implant", "missing", "extraction"]);

export {
  Caries, RCT, Composite, Amalgam, Implant, Bridge,
  Missing, Fracture, Crown, Mobility, PeriapicalLesion,
};
